module.exports = __webpack_public_path__ + "img/head-shoulders_hover.a7db2bba.png";